export default __webpack_public_path__ + "static/cloud_app_banner-a957d1c3e650b34992b8e70e8cd43ccc.webp";